'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createFieldArray = require('../createFieldArray');

var _createFieldArray2 = _interopRequireDefault(_createFieldArray);

var _immutable = require('../structure/immutable');

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createFieldArray2.default)(_immutable2.default);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/immutable/FieldArray.js
// module id = 3057
// module chunks = 0